import React, {Component} from 'react'
import Waypoint from 'react-waypoint'
import classNames from 'classnames'
import {StickyContainer, Sticky} from 'react-sticky'
import SocialShareOptions from '../SocialShareOptions/SocialShareOptions'
import ArticlesList, {ARTICLES_LIST_DIRECTION_VERTICAL} from '../ArticlesList/ArticlesList'
import {ARTICLE_PREVIEW_TYPE_RELATED} from '../../constants/articles'
import {useGatedContent} from 'env'

class ArticleAside extends Component {
  constructor (props) {
    super(props)
    this.handleOnPositionChange = this.handleOnPositionChange.bind(this)
  }

  componentDidMount () {
    const {setArticlePagePassedSocialWaypoint} = this.props
    setArticlePagePassedSocialWaypoint(false)
  }

  handleOnPositionChange (position) {
    const {setArticlePagePassedSocialWaypoint} = this.props
    if (position.currentPosition === 'above') {
      setArticlePagePassedSocialWaypoint(true)
    } else {
      setArticlePagePassedSocialWaypoint(false)
    }
  }

  renderCategorySection (isSticky, style) {
    const {articles} = this.props
    return (
      <div className={classNames([
        'ArticleAside__category',
        {
          'ArticleAside__category--sticky': isSticky
        }
      ])} style={style}>
        <div className='ArticleAside__category__title'>Related</div>
        <ArticlesList useAlternative listOf={2} articles={articles} direction={ARTICLES_LIST_DIRECTION_VERTICAL}
          articlePreviewType={ARTICLE_PREVIEW_TYPE_RELATED} />
      </div>
    )
  }

  renderSticky () {
    const {subscriptionRequired} = this.props
    const enabled = !useGatedContent() || !subscriptionRequired
    if (enabled) {
      return (
        <StickyContainer>
          <Sticky topOffset={-50}>
            {
              ({isSticky, style}) => this.renderCategorySection(isSticky, style)
            }
          </Sticky>
        </StickyContainer>
      )
    }
    return this.renderCategorySection(false, {})
  }

  render () {
    const {article} = this.props
    return (
      <aside className='ArticleAside'>
        <Waypoint
          onPositionChange={this.handleOnPositionChange}
        />
        <div style={{ 'whiteSpace': 'nowrap' }} className='ArticleAside__category__title'>
          Share This Article
        </div>
        <div className='ArticleAside__social'>
          <SocialShareOptions article={article} />
        </div>
        <div className='ArticleAside__categoryWrapper'>
          {this.renderSticky()}
        </div>
      </aside>
    )
  }
}

ArticleAside.defaultProps = {}

export default ArticleAside



// WEBPACK FOOTER //
// ./client/components/ArticleAside/ArticleAside.js